import type { OrderCardItem } from '../OrderCardList/OrderCardList';

import type { OrderCardData } from './order-card-types';

export type SectionState = 'open' | 'closed' | null;

type OrderCardLayout = {
  list: boolean;
  timeline: boolean;
  facts: boolean;
  events: SectionState;
  items: SectionState;
};

// Läget säger vad kortet VILL visa och vad som är utfällt från start. En
// sektion utan data ritas ändå inte — den regeln bor i mallen, inte här.
export const orderCardLayout = (view: string): OrderCardLayout => {
  switch (view) {
    case 'overview':
      return { list: true, timeline: true, facts: false, events: null, items: null };
    case 'return':
      return { list: true, timeline: true, facts: false, events: null, items: 'closed' };
    case 'items':
      return { list: false, timeline: false, facts: false, events: null, items: 'open' };
    case 'shipping':
      return { list: false, timeline: true, facts: true, events: 'open', items: 'closed' };
    default:
      return { list: false, timeline: true, facts: true, events: 'closed', items: 'open' };
  }
};

// Översikten och returen är widgetens listkort — samma komponent ritar dem,
// bara fältnamnen skiljer mellan de gamla blocken och ORDER_CARD.
export const toListCardItem = (view: string, card: OrderCardData): OrderCardItem => ({
  kind: view === 'return' ? 'return' : 'order',
  orderNumber: card.orderNumber,
  placedAtIso: card.placedAt,
  itemCount: Number(card.itemCount) || 0,
  totalPrice: card.totalPrice,
  currency: card.currency,
  products: [],
  actions: [],
  timeline: card.timeline,
  footAction: card.footAction,
  returnScope: card.return?.scope,
  statusLabel: card.return?.statusLabel,
  refundAmount: card.return?.refundAmount,
  items: card.items,
});
